<div [formGroup]="formGroupElement">
    <mat-form-field fxFlex [floatLabel]="'always'">
        <mat-label>{{ label | translate }}</mat-label>
        <input type="text" [placeholder]="placeholder | translate" matInput [name]="controlName" [formControlName]="controlName" [matAutocomplete]="autoDeparture" />
        <mat-autocomplete autoActiveFirstOption #autoDeparture="matAutocomplete" (optionSelected)="onAirportOptionSelected($event)">
            @if (!departureIsLoading) {
                @for (option of filteredDepartureAirportOptions; track option) {
                    <mat-option [value]="option">
                        {{ option.city + (option.code ? "-" : "") + (option.code ? option.code : "") }}
                    </mat-option>
                }
            }
        </mat-autocomplete>
        @if (formGroupElement.controls[controlName].hasError("required")) {
            <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
        }
    </mat-form-field>
</div>
